/**
 * IP アドレスの表示用ヘルパ。
 *
 * 設計意図 (issue #39):
 *   アクセスログの「アクセス元」列では、サーバから渡された IP を **第3オクテットまで** に
 *   切り詰めて表示する。ピンポイントの追跡は避けつつ、地域がだいたい分かる程度の粒度に揃える。
 *
 *   - 既にマスク済み (`****`) はそのまま返す（FREE プランの maskAccessLog 結果）
 *   - IPv4 (例: `192.168.1.42`) → `192.168.1.*`
 *   - IPv6 (例: `2001:db8::1`) → 先頭 3 セグメント + `:*`
 *   - パースできない値はそのまま返す（壊さない）
 */

const MASK_LITERAL = '****'

export function truncateIp(ip: string | null | undefined): string {
  if (!ip) return '—'
  if (ip === MASK_LITERAL) return ip // FREE プランのマスク表現はそのまま見せる

  // IPv4: ドット区切り 4 オクテット
  const ipv4 = ip.match(/^(\d{1,3})\.(\d{1,3})\.(\d{1,3})\.\d{1,3}$/)
  if (ipv4) return `${ipv4[1]}.${ipv4[2]}.${ipv4[3]}.*`

  // IPv6: コロン区切り。先頭 3 セグメントだけ見せる
  // `::` 短縮形にも軽く対応（最初の `::` 出現を 1 セグ扱い）
  if (ip.includes(':')) {
    const segments = ip.split(':').slice(0, 3).join(':')
    return `${segments}:*`
  }

  // 想定外のフォーマットはそのまま（破壊しない）
  return ip
}
